import React, { useEffect, useState } from "react";
import BoundingBox from "../assets/bounding-box.svg";
import { END_POINT_SEVER } from "../constants";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { WarningError } from "../helpers/alertseet";

let PRESIGNED_URL = END_POINT_SEVER + "/api/file/generatePresignedUrl";
export default function UploadImageComponent({
  src,
  isInvalid,
  onChange,
  style,
}) {
  const [imageLoading, setImageLoading] = useState();
  const [imageLoadingPercent, setImageLoadingPercent] = useState();
  const [imgSrc, setImgSrc] = useState(null);
  // useEffect
  useEffect(() => {
    const img = new Image();
    if (src) {
      img.src = src;
      setImgSrc(img.src);
    }
    // Clean up logic if needed
    return () => {
      // Cleanup logic if needed
    };
  }, [src]);
  // function
  const handleUpload = async (event) => {
    // setImageWarning(false)

    try {
      if (!event.target.files[0]) {
        return;
      }
      const file = event.target.files[0];
      const maxSize = 3 * 1024 * 1024; // 3MB in bytes
      if (file && file.size > maxSize) {
        WarningError("ຂະໜາດຮູບຕ້ອງບໍ່ເກີນ 3MB");
        event.target.value = null;
        return;
      }

      setImageLoading(true);
      setImageLoadingPercent(0);
      let fileData = event.target.files[0];

      // generate file name 
      let generateName = "";
      let result = "microfinance";
      let characters = "0123456789";
      let charactersLength = characters.length;
      for (var i = 0; i < 9; i++) {
        generateName = result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
    
  const parts = fileData?.name.split(".");
      const newImageName = generateName + "." + parts[parts.length - 1];
      const presignData = JSON.stringify({ fileName: newImageName });

      const responseUrl = await axios({
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        url: PRESIGNED_URL,
        data: presignData
      });

    console.log("response:::",responseUrl);
      await axios({
        method: "put",
        url: responseUrl?.data?.uploadUrl,
        data: fileData,
        headers: {
          "Content-Type": " file/*; image/*",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
          "Access-Control-Allow-Headers":
            "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
        },
        onUploadProgress: function (progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setImageLoadingPercent(percentCompleted);
        },
      });
      setImageLoading(false);
      onChange(newImageName);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <label
        style={{
          border: `2px dashed ${isInvalid ? "#ff0000" : "#ccc"}`,
          borderRadius: 8,
          overflow: "hidden",
          cursor: "pointer",
          ...style,
        }}
        htmlFor="upload_img"
      >
        <div
          style={{
            display: imageLoading ? "flex" : "none",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            width: "100%",
            height: "100%",
            opacity: 0.8,
            gap: 10,
          }}
        >
          <Spinner
            animation="border"
            variant="gay"
            style={{
              width: 40,
              height: 40,
              borderWidth: 6,
            }}
          />
          <div style={{ fontSize: 20, fontWeight: 700 }}>
            {imageLoadingPercent}/100
          </div>
        </div>
        <div
          style={{
            display: imgSrc || imageLoading ? "none" : "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            padding: 20,
            height: "100%",
            width: "100%",
          }}
        >
          <img
            src={BoundingBox}
            alt="bounding-box"
            style={{ width: 48, height: 48 }}
          />
          <div>
            <span style={{ color: "#0178c1" }}>ເລືອກຮູບ</span> ທີ່ຈະອັບໂຫລດ
            <br />
            <span>PNG, JPG</span>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            height: "100%",
            display: imgSrc && !imageLoading ? "block" : "none",
            ...style,
          }}
        >
          <img
            src={imgSrc}
            alt=""
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>
      </label>
      <input
        id="upload_img"
        type="file"
        accept="image/png, image/jpeg, image/jpg"
        onChange={handleUpload}
        style={{ display: "none" }}
      />
    </div>
  );
}
